import React from 'react';
import { Card } from 'react-bootstrap';
import { BRAND_PURPLE } from './nodes/connectorColor';

// #2662: explains what each connecting-line color/style on the canvas means, since several of
// them (True/False/Error/End Loop) aren't otherwise obvious without hovering or zooming in on a
// label. Kept as plain CSS border swatches (not real SVG paths) -- close enough to the real
// rendering to recognize, without duplicating DraggableEdge's actual path-drawing logic here.
const LEGEND_ITEMS = [
  { label: 'Next', borderStyle: 'solid', color: '#cf7f00' },
  { label: 'True', borderStyle: 'solid', color: '#10b981' },
  { label: 'False', borderStyle: 'solid', color: '#f59e0b' },
  { label: 'Error', borderStyle: 'dashed', color: '#ef4444' },
  { label: 'To End Loop', borderStyle: 'solid', color: BRAND_PURPLE },
];

function EdgeLegend() {
  return (
    <Card className="mt-2">
      <Card.Body className="p-2">
        <div className="small text-muted mb-2 fw-semibold">Line Legend</div>
        {LEGEND_ITEMS.map(({ label, borderStyle, color }) => (
          <div key={label} className="d-flex align-items-center gap-2 mb-1">
            <div
              style={{
                width: '24px',
                borderTop: `3px ${borderStyle} ${color}`,
              }}
            />
            <span className="small">{label}</span>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
}

export default EdgeLegend;
